import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import { useContent } from '../../hooks/useContent';

export default function Footer() {
  const { content } = useContent();
  const f = content?.footer;
  const quickLinks = f?.quickLinks ?? [
    { label: 'About Us', path: '/about' }, { label: 'Services', path: '/services' },
    { label: 'Products', path: '/remedies' }, { label: 'Blog', path: '/blog' }, { label: 'Contact', path: '/contact' },
  ];
  const serviceLinks = f?.serviceLinks ?? [
    { label: 'Residential Vastu', path: '/services/residential' }, { label: 'Commercial Vastu', path: '/services/commercial' },
    { label: 'Industrial Vastu', path: '/services/industrial' }, { label: 'Professional Spaces', path: '/services' },
    { label: 'Plot Selection', path: '/services' }, { label: 'Vastu Audit', path: '/services' },
  ];
  const support = f?.support ?? [{ icon: '✉️', text: 'info@theperfectvaastu.com' }, { icon: '📞', text: 'Call us for enquiry' }];
  const symbols = f?.symbols ?? ['ॐ', '☸', '✦'];

  return (
    <footer style={{ background: '#08081A', borderTop: '1px solid rgba(232,135,26,0.15)', paddingTop: 64 }}>
      <div className="container">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 48, paddingBottom: 48 }}>
          {/* Brand */}
          <div>
            <Logo size={36} showText={true} animate={false} />
            <p style={{ fontSize: 13, lineHeight: 1.8, opacity: 0.6, marginBottom: 20, marginTop: 12 }}>
              {f?.tagline}
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              {symbols.map((sym: string, i: number) => (
                <span key={i} style={{ fontSize: 20, color: '#E8871A', opacity: 0.6 }}>{sym}</span>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 16, color: '#E8871A', marginBottom: 20 }}>Quick Links</p>
            {quickLinks.map((l: any) => (
              <Link key={l.path} to={l.path} style={{
                display: 'block', fontSize: 13, color: '#FDF6EC', opacity: 0.6,
                textDecoration: 'none', marginBottom: 10, transition: 'opacity 0.2s'
              }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '1')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '0.6')}
              >→ {l.label}</Link>
            ))}
          </div>

          {/* Services */}
          <div>
            <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 16, color: '#E8871A', marginBottom: 20 }}>Services</p>
            {serviceLinks.map((l: any) => (
              <Link key={l.label} to={l.path} style={{
                display: 'block', fontSize: 13, color: '#FDF6EC', opacity: 0.6,
                textDecoration: 'none', marginBottom: 10, transition: 'opacity 0.2s'
              }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '1')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '0.6')}
              >→ {l.label}</Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 16, color: '#E8871A', marginBottom: 20 }}>Support</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {support.map((c: any, i: number) => (
                <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 14 }}>{c.icon}</span>
                  <span style={{ fontSize: 13, opacity: 0.6 }}>{c.text}</span>
                </div>
              ))}
            </div>
            <Link to={f?.cta?.path ?? '/contact'} className="btn-primary" style={{ marginTop: 20, display: 'inline-block', fontSize: 12, padding: '8px 16px' }}>
              {f?.cta?.label ?? 'Enquire Now'}
            </Link>
          </div>
        </div>

        <div className="footer-bottom" style={{
          borderTop: '1px solid rgba(232,135,26,0.1)',
          padding: '24px 0',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 12
        }}>
          <p style={{ fontSize: 12, opacity: 0.4 }}>
            © {new Date().getFullYear()} {f?.copyright ?? 'The Perfect Vaastu. All rights reserved.'}
          </p>
          <p style={{ fontSize: 12, opacity: 0.4 }}>
            {f?.bottomTagline ?? 'Align Your Space. Transform Your Life.'}
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .footer-bottom { flex-direction: column; text-align: center; }
        }
      `}</style>
    </footer>
  );
}
